const createLogger = require('@techstyle/debug').default;

module.exports = createLogger('~/techstyle-shared/next-server');
